var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTagsSolid = function SvgTagsSolid(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 436.38 436.38",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.38 23.224H206.396a32 32 0 0 0-22.624 9.376L9.372 206.968c-12.496 12.496-12.496 32.752 0 45.264l133.984 133.984c12.496 12.496 32.752 12.496 45.248 0l174.4-174.368c6-6.016 9.376-14.16 9.376-22.656V55.224c0-17.68-14.32-32-32-32m-56 112c-13.248 0-24-10.752-24-24s10.752-24 24-24 24 10.752 24 24-10.752 24-24 24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m404.38 55.224-.016 148.944a27.8 27.8 0 0 1-8.16 19.68L218.988 401.064l2.72 2.72c12.496 12.496 32.752 12.496 45.248 0l160.032-160a31.96 31.96 0 0 0 9.392-22.624V87.224c0-17.68-14.32-32-32-32"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTagsSolid);
export default ForwardRef;